export default [
    {
        path: 'acompanhamentos/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'PafController' }
    },
    {
        path: 'acompanhamento/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'PafController' },
    },
    {
        path: 'acompanhamento/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'PafController'
        }
    },
    {
        path: 'relatorios/acompanhamentos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/acompanhamentos/home',
        meta: { middleware: 'auth', controller: 'RelatorioPafController' },
        children: [{
            path: 'home',
            name: "relatorios_home_acompanhamentos",
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioPafController' },
        }, {
            path: 'graficos',
            name: "graficos_acompanhamentos",
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioPafController' },
        }
        ]
    }
];


